import React from 'react';

export default function Splash() {
  return (
    <div className="splash">
      <div className="splash-emoji">🎵</div>
      <div className="splash-title">hé pardon!!</div>
      <div className="splash-sub">Music · Download · IA · Paroles</div>
      <div className="splash-bar">
        <div className="splash-bar-fill" />
      </div>
    </div>
  );
}
